var map = {
	"./high.jpg": 87538,
	"./highest.jpg": 60849,
	"./low.jpg": 32313,
	"./moderate.jpg": 59677,
	"./normal.jpg": 80641,
	"./normal1.jpg": 39591,
	"./vulnerable.jpg": 39851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2348;